import { AccessLevelE, UserRoleE } from "../../models/enums";
import { mapClientTypeToRole } from "./mapClientTypeToRole";

export default (userData: any, clientData: any) => {
    if (clientData.IsContentManager) return UserRoleE.GlobalAdminAndAdminContentManager;
    if (userData.AccessLevel === AccessLevelE.GlobalAdmin) return UserRoleE.GlobalAdmin;
    if (userData.AccessLevel === AccessLevelE.DeliveryServicePrivate) return UserRoleE.DeliveryService;
    return mapClientTypeToRole(clientData.ClientType);
}